<template>
  <div class="divMessageInfoTotalWrap">
      <el-tabs :value="tabType" @tab-click="handleClick">
          <el-tab-pane label="默认文案(无需审核)" name="0">
            <div v-if="!!this.userInfo">
             <!-- 【出行券】尊敬的客户，{{userInfo.companyName}} 发送给您的出行券已放入您的滴滴出行-钱包中，使用滴滴出行APP或小程序叫车时可以自动抵扣支付。退订TD -->
             【出行券】尊敬的客户，您的出行券已被放入您的滴滴出行-钱包中，使用滴滴出行APP或小程序叫车时可抵扣车费。退订TD
            </div>
          </el-tab-pane>
          <el-tab-pane label="创建新的文案(需审核)" name="1">
             【出行券】尊敬的客户，
              <el-form-item label="" style="width: 235px; display: inline-block; margin-right: 5px" prop="smsCompanyName">
                  <el-input placeholder="请输入如“人保公司”，最多20字" :value="messageInfoInput" @input="inputMessageInfoDoc"></el-input>
              </el-form-item>
              <div style="margin-top: 5px; display: inline;">发送给您的出行券已放入您的滴滴出行-钱包中，使用滴滴出行APP或小程序叫车时可以自动抵扣支付。退订TD</div>
          </el-tab-pane>
          <el-tab-pane label="使用原有文案(无需审核)" name="2" :disabled="this.messageInfoDocList && this.messageInfoDocList.length === 0">
              <div class="divMessageInfoWrap">
                  <div class="divMessageInfoDivWrap">
                    <div class="divMessageInfoRadioWrap" v-for="(item, index) in messageInfoDocList" :key="index">
                      <el-radio v-model="messageInfoChooseId" :label="item.id" @change="radioChange(index)">{{item.smsTxt}}</el-radio>
                    </div>
                  </div>
              </div>
          </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>
import CouponCard from '../../../components/CouponCard'
import {mapState} from 'vuex'

export default {
name: 'MessageInfoDocument',
data () {
  return {
    messageInfoInput: '',
    messageInfoChoose: '',
    messageInfoChooseId: '',
    messageInfoChooseDefault: -1,
    tabType: '0',
    messageInfoDocList: null,
    messageInfoDocData: null,
    smsTemplateIdData: null
  }
},
methods: {
  handleClick (tab, event) {
    if (tab.name === '0') {
      this.callbackMsg('0')
    } else if (tab.name === '1') {
      this.callbackMsg('1')
    } else if (tab.name === '2') {
      this.callbackMsg('2')
    }
    this.tabType = tab.name
  },
  radioChange (index) {
    this.messageInfoChoose = this.messageInfoList[index].smsTxt
    this.messageInfoChooseId = this.messageInfoList[index].id
    this.callbackMsg('2')
  },
  inputMessageInfoDoc (messageInfoDoc) {
    this.messageInfoInput = messageInfoDoc
    this.callbackMsg('1')
  },
  callbackMsg (type) {
    if (type === '0') {
      this.callback({
        messageInfoChooseId: -1,
        messageInfoDoc: '标准短信'//this.userInfo.companyName
      })
    } else if (type === '1') {
      this.callback({
        messageInfoDoc: this.messageInfoInput
      })
    } else if (type === '2') {
      this.callback({
        messageInfoChooseId: this.messageInfoChooseId,
        messageInfoDoc: this.messageInfoChoose
      })
    }
  }
},
computed: {
  ...mapState('header', ['userInfo'])
  // ...mapGetters('header',['selfGroup'])
},
watch: {
  messageInfoDoc (val) {
    if (val.length === 0) {
      this.messageInfoInput = ''
    }
  }
},
created: function () {
  this.messageInfoDocList = this.messageInfoList || null
  this.messageInfoDocData = this.messageInfoDoc || null
  this.smsTemplateIdData = this.smsTemplateId || null
  let tabType = '0'
  if (this.messageInfoDocList.length) {
    this.messageInfoChooseId = this.messageInfoDocList[0].id
    this.messageInfoChoose = this.messageInfoDocList[0].smsTxt
  }
  let chooseFlag = false
  for (let i = 0; i < this.messageInfoDocList.length; i++) {
    if (this.messageInfoDocList[i].id === this.smsTemplateIdData) {
      chooseFlag = true
      this.messageInfoChooseId = this.smsTemplateIdData
      this.messageInfoChoose = this.messageInfoDocList[i].smsTxt
      break
    }
  }
  if (chooseFlag) {
    tabType = '2'
  } else if (this.smsTemplateIdData === '0') {
    tabType = '1'
    this.messageInfoInput = this.messageInfoDocData
  } else {
    tabType = '0'
  }

  this.tabType = tabType
  this.callbackMsg(tabType)
},
components: {
  CouponCard
},
props: ['callback', 'messageInfoList', 'messageInfoDoc', 'smsTemplateId']
}
</script>

<style lang="stylus">
  .divMessageInfoTotalWrap {
    width: 548px;
    .el-form-item__error {
      padding-top: 1px;
    }

    .divMessageInfoWrap {
        background: #F3F4F5;
        border-radius: 4px;
        max-height: 180px;
        overflow: auto;
        box-sizing: border-box;
        width: 540px;

        .divMessageInfoDivWrap {
            margin: 0 auto;
            padding: 6px 8px;

          .divMessageInfoRadioWrap {
              line-height: initial;
              margin: 10px 0;
          }
          .divMessageInfoRadioWrap:first-child {
            margin-top: 0;
          }
          .divMessageInfoRadioWrap:last-child {
            margin-bottom: 0;
          }
        }
    }
  }
</style>
